import { useCallback, useContext } from "react";
import { MainContext } from "../../contexts";
import { Permissions } from "./permissions.interface";
import { useStorage } from "../useStorage";

const RETRY_TIMEOUT = 500;

export interface TryActionProps {
  testFn: (permissions: Permissions) => boolean;
  onSuccess: () => any;
  onError?: () => void;
  onDismiss?: () => void;
};

export const usePermissions = () => {
  const { getPermissions } = useStorage();
  const { openLogin } = useContext(MainContext);

  const tryAction = useCallback(({ testFn, onDismiss, onSuccess, onError }: TryActionProps) => (
    new Promise((res, rej) => {
      if (testFn(getPermissions())) {
        res(onSuccess());
      } else {
        if (openLogin) {
          openLogin({
            onDismiss: () => { if (onDismiss) onDismiss(); rej() },
            onError: () => { if (onError) onError(); rej() },
            onSuccess: () => {
              setTimeout(() => {
                tryAction(
                  {
                    testFn,
                    onDismiss,
                    onSuccess: () => res(onSuccess()),
                    onError,
                  },
                );
              }, RETRY_TIMEOUT);
            },
            showMessageError: true
          });
        }
      }
    })
  ), [openLogin]);

  return { tryAction };
};
